<template>
  <div :ref="myRef" :style="style"></div>
</template>
<script>
  var echarts = require('echarts')
  export default {
    data () {
      return {
        myChart: {}
      }
    },
    watch: {
      option: {
        handler (v) {
          this.option = v
          this.reload()
        },
        deep: true
      }
    },
    props: {
      option: {  //echarts的option值
        type: Object,
        default: {}
      },
      myRef: {   //ref值
        type: String,
        default: 'echart'
      },
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '600px'
      },
    },
    computed: {
      style () {
        let style = {}
        if (this.width) {
          style.width = this.width
        }
        if (this.height) {
          style.height = this.height
        }
        return style
      }
    },
    methods: {
      reload () {   //重新渲染数据图表
        this.myChart.clear()
        this.myChart.setOption(this.option, true)
        // 浏览器窗口改变，echarts 大小改变
        let that = this
        window.addEventListener('resize', function () {
          that.myChart.resize()
        })
      }
    },
    mounted () {
      //  初始化echarts实例
      this.myChart = echarts.init(this.$refs[this.myRef])
      this.myChart.setOption(this.option)
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/echarts/index.vue